<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

/* .select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
} */

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
.button-area{
  display: flex;
  justify-content:space-between;
  align-items: center
}
</style>
<template>
  <div>
    <div class="content" v-loading.fullscreen.lock="fullscreenLoading" v-show="!showDialogBox">
      <!-- search start -->
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">支付方&nbsp;&nbsp;&nbsp;</div>
            <el-select size="mini" class="ipt-sty" v-model="page.payTenantGuid" placeholder="请选择" filterable>
              <el-option v-for="item in invoiceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">收款方&nbsp;&nbsp;&nbsp;</div>
            <el-select size="mini" class="ipt-sty" v-model="page.receiveTenantGuid" placeholder="请选择" filterable>
              <el-option v-for="item in receiveTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">付款日期</div>
            <!-- <el-date-picker size="mini" class="ipt-sty" type="date" placeholder="请选择"
              v-model="page.invoiceDate"></el-date-picker> -->
            <el-date-picker
              size="mini"
              v-model="invoiceDate"
              type="daterange"
              class="ipt-sty"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? '收起筛选' : '更多筛选' }}
            </el-button>
            <el-button size="mini" type="info" @click="search(true)">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div">对应款项</div>
            <el-select size="mini" class="ipt-sty" v-model="page.correspondItem" placeholder="请选择" filterable>
              <el-option
                v-for="item in getCodeListByKey('对应款项')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">流程编号</div>
            <el-input size="mini" placeholder="请输入流程编号" class="ipt-sty" v-model="page.approveFlowNo" />
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">药企名称</div>
            <el-select size="mini" class="ipt-sty" v-model="page.operationReportTenantGuid" placeholder="请选择" filterable>
              <el-option
                v-for="item in sendTenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <!-- search end -->

      <!-- table start -->
      <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px'">
        <div class="button-area">
          <div>
            <el-button v-if="getBtnPermissionsByName('新增付款信息')" icon="el-icon-plus" size="mini" type="info" @click="addCollectionInfo">新增付款信息</el-button>
            <el-button v-if="getBtnPermissionsByName('导出')" size="mini" type="info" @click="bitchExport" v-loading.fullscreen.lock="fullscreenLoading"
              >导出</el-button>
          </div>
          <div v-if="totalLoading">
            <span style="color: #FF5F1F;">正在合计中...</span>
          </div>
          <div v-else>
            合计付款金额：<span>{{ amountSumOne |numDigit }}</span>&nbsp;元
          </div>
        </div>
        <el-table ref="tableRef" border :height="tableHeight" :data="tableData" stripe style="width: 100%" v-loading="tableLoading">
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="approveFlowNo" label="流程编号" min-width="110" header-align="center" align="left">
            <template slot-scope="scope">
              <div class="select-department-new" @click="lookFlow(scope.row.approveFlowNo)">
                {{ scope.row.approveFlowNo || '-'}}
              </div>
              </template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="支付方" show-overflow-tooltip header-align="center" align="left"
            width="210">
            <template slot-scope="scope">{{ scope.row.payTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="templateName" label="收款方" show-overflow-tooltip header-align="center" align="left"
            width="210">
            <template slot-scope="scope">{{ scope.row.receiveTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="operationReportTenantName" label="药企名称" show-overflow-tooltip header-align="center" align="left"
            width="210">
            <template slot-scope="scope">{{ scope.row.operationReportTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column width="160" prop="createTime" label="付款日期" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.receiveDate | getDate }}</template>
          </el-table-column>
          <el-table-column  width="120" prop="taskTotal" label="对应款项" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ getName(scope.row.correspondItem, '对应款项') }}</template>
          </el-table-column>
          <el-table-column  width="120" prop="receiveAmount" label="付款金额(元)" show-overflow-tooltip header-align="right" align="right">
            <template slot-scope="scope">{{ scope.row.receiveAmount | numDigit }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="操作人" width="120" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
          </el-table-column>
          <el-table-column width="160" prop="createTime" label="操作时间" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.updateTime | getTime }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="数据来源"  min-width="96" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.sourceType | sourceTypeFilter }}</template>
          </el-table-column>
          <el-table-column prop="bank" min-width="140px" label="操作" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <div>
               <a class="txt-color" v-if="scope.row.createUserId === userinfo.userGuid||getBtnPermissionsByName('编辑')" scope.row @click="editForm(scope.row.guid,scope.$index)">编辑&nbsp;&nbsp;</a>
              <a class="txt-color" v-if="getBtnPermissionsByName('详情')" @click="lookForm(scope.row.guid,scope.$index)">详情&nbsp;&nbsp;</a>
              <a class="txt-color" v-if="scope.row.createUserId === userinfo.userGuid||getBtnPermissionsByName('删除')" @click="delForm(scope.row.guid)">删除</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
      <!-- table end -->
    </div>
    <AddCollectionDialogBox
      ref="AddCollectionDialogBox"
      :paramCollection="paramCollection"
      :invoiceTenantList="invoiceTenantList"
      :receiveTenantList="receiveTenantList"
      :sendTenantList="sendTenantList"
      :tenantDetail="tenantDetail"
      :show-contract="true"
      @closedDialogBox="closedDialogBox"
    ></AddCollectionDialogBox>
  </div>
</template>

<script>
import AddCollectionDialogBox from './components/addCollectionDialogBox';
import { route } from '@/api/apiRoute';
import store from '@/store';
import btnPermisson from '../mixins/btnPermisson';
import getTenantDetail from '../mixins/getTenantDetail';

export default {
  mixins:[btnPermisson, getTenantDetail],
  components: {
    AddCollectionDialogBox,
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      totalLoading:true,
      tableData: [],
      invoiceDate: [], // 开票日期
      page: {
        streamType: '2', // 下游游
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        payTenantGuid: '', //开票方
        receiveTenantGuid: '', //收票方
        correspondItem: '', //对应款项
        startDate: '',
        endDate: '',
        approveFlowNo: null,
        operationReportTenantGuid: '', //药企名称
        serviceTenantGuid:localStorage.guid
      },
      paramCollection: {
        // 新增收款信息传递参数
        streamType: '2', //  1上游 2下游
        index: '', // 款项信息的索引
        title: '',
        operationType: '',
        invoiceTenantGuid: '', // 收票方（支付方）唯一标识
        invoiceTenantName: '', // 收票方（支付方）name
        receiveTenantGuid: '', // 开票方（收款方）唯一标识
        receiveTenantName: '', // 开票方（收款方）name
        correspondItem: '', //对应款项
        operationReportTenantGuid:'',//药企名称
      },
      invoiceTenantList: [],
      receiveTenantList: [],
      sendTenantList:[],
      showDialogBox: false, // 显示收款信息表单
      amountSumOne:'',//合计付款金额
      tenantDetail: {},
    };
  },
  watch:{
    showMore(val, oldVal) {
            if (val) {
                this.tableHeight = window.innerHeight - 310;
                return;
            }
            if (!val) {
                this.tableHeight = window.innerHeight - 263;
                this.contentMainHeight = window.innerHeight - 200;
                return;
            }
        }
  },
  created() {
    this.getMenuList(); // 获取按钮配置
    this.getList();
    this.getInvoiceTenantList();
    this.getReceiveTenantList();
    this.getSendTenantList()
    this.getServiceProviderType();
  },
  methods: {
    async getServiceProviderType() {
      await this.Mixins_getServiceProviderType();
      // 可以直接访问到 mixins 中的 data 变量
      this.tenantDetail = this.Mixins_tenantDetail;
    },
    getSumAmount(list,attr) {
      let sum = 0;
      list.forEach(item => {
        // sum += item.settleAmount;
        sum += Math.round(item[attr] * 100) / 100 ;
      })
      return sum
    },
    // 查看流程详情
    lookFlow(flowNo) {
      if(!flowNo)return
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      self.tableLoading = true;
      let postData={
        pageIndex: 1,
        pageSize: 50,
        flowTypeList:["00022"],
        serviceTenantGuid: localStorage.guid,
        staffGuid: userInfo.staffGuid,
        applyStaffGuid: null,
        flowNo: flowNo,
        isHedge: null,
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/page-list`, postData).then((res) => {
        self.tableLoading = false;
        let { code, msg, data } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = data.records || [];
          if(!list||list.length==0){
            self.$message.error("您没有查看权限");
            return;
          }
          if(list&&list.length==1){
            let item=list[0]
            const maxDate = '202511010000'
            if (flowNo < maxDate) {
              this.$router.push({
                path: '/downstreamPaymentDetail_old',
                query: {
                  guid: item.guid,
                  approveVO: JSON.stringify(item.approveVO),
                },
              });
              return;
            }
            this.$router.push({
              path: '/downstreamPaymentDetail',
              query: {
                guid: item.guid,
                approveVO: JSON.stringify(item.approveVO),
                // productGuid: this.$route.query.productGuid,
              },
            });
          }	
        } else {
          self.$message.error(msg);
        }
      });
    },
    // 获取药企列表
    getSendTenantList() {
      let that = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        guid: "",
        bizState: "Y",
        relType: '123', // 写死 支持选自己
        enterpriseCates: this.$getValueListByKey('上游客户分类')
      }
      that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res;
          if (data.data && data.data.records) {
            that.sendTenantList = data.data.records || [];
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //批量导出
    bitchExport() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        streamType: '2',
        payTenantGuid: this.page.payTenantGuid, // #开票方
        receiveTenantGuid: this.page.receiveTenantGuid, // #收票方
        correspondItem: this.page.correspondItem,
        operationReportTenantGuid: this.page.operationReportTenantGuid, //药企名称
        receiveDateEnd: this.invoiceDate[1] || '',
        receiveDateStart: this.invoiceDate[0] || ''
      };
      self.fullscreenLoading = true;
      self.api.postJsonD(`/${serverConfig.msCustomerService}/invoiceItem/export-downstream`, req).then((res) => {
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let fileName = '下游付款信息' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = fileName;
        link.href = objectUrl;
        link.click();
        self.fullscreenLoading = false;
      });
    },
    //获取下游支付方 --- 服务商(支付方)
    getInvoiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取下游收款方 --- 代征代缴(收款方)
    getReceiveTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
        relType: '123', // 写死 支持选自己
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.receiveTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    search(flg) {
      let self = this;
      if(flg){
        this.page.pageIndex = 1;
      }
      this.page.receiveDateStart = this.invoiceDate[0] || '';
      this.page.receiveDateEnd = this.invoiceDate[1] || '';
      this.getAmount()
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAmount() {
      let self = this;
      let req=JSON.parse(JSON.stringify(this.page))
      req.pageSize=-1
      req.pageIndex = 1;
      self.totalLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/amount-sum`, req).then((res) => {
        self.totalLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.amountSumOne = res.data.data;
          self.$forceUpdate()
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.invoiceDate = [];
      this.page = {
        streamType: '2', // 下游
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        invoiceTenantGuid: '', //开票方
        receiveTenantGuid: '', //收票方
        correspondItem: '', //对应款项
        startDate: '',
        endDate: '',
        approveFlowNo: null,
        operationReportTenantGuid: '', //药企名称
        serviceTenantGuid:localStorage.guid
      }
        this.getList();
    },
    addVersion() {
      this.$router.push('/upstreamInvoiceEdit?productGuid='+this.$route.query.productGuid);
    },
    editForm(guid, index) {
      this.$store.commit('setPageY', index);
      this.editCollectionInfo(guid, 'edit');
    },
    lookForm(guid, index) {
      this.$store.commit('setPageY', index);
      this.editCollectionInfo(guid, 'look');
    },
    getList(callBack) {
      let self = this;
      this.getAmount()
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          if (callBack) callBack();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除
    delForm(guid) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/del`, [guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // 去添加收款信息
    addCollectionInfo() {
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.title = '新增下游付款信息';
      this.paramCollection.operationType = '列表新增方式';
      this.paramCollection.invoiceTenantGuid = ''; // 收票方（支付方）唯一标识
      this.paramCollection.invoiceTenantName = ''; // 收票方（支付方）name
      this.paramCollection.receiveTenantGuid = ''; // 开票方（收款方）唯一标识
      this.paramCollection.receiveTenantName = ''; // 开票方（收款方）唯一标识
      this.paramCollection.correspondItem = ''; // 对应款项
      this.paramCollection.operationReportTenantGuid = ''; // 药企名称
    },
    editCollectionInfo(guid, type) {
      let { form } = this;
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.title = '编辑下游付款信息';
      this.paramCollection.operationType = '列表编辑方式';
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/invoiceItem/detail/${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res.data;
          this.$root.$emit('collection-editAndLookData', { data, type });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    closedDialogBox(val) {
      if (val === 'closed') {
        this.showDialogBox = false;
         this.getList(()=>{
          if (this.$store.getters.getPageY) this.tableScrollToRow(this.$refs.tableRef, this.$store.getters.getPageY); // 表格行跳转
        });
      }
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>
<style scoped>
.select-department-new {
  color: green;
  cursor: pointer;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>
